import React, { useEffect, useState } from 'react'
import { Row, Card, Form, Input, Space, Button, Col, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'
import { sendEmailForExpressPolicyChanges } from '../services'
import { ADD_DRIVER_JSON_MAP } from './AddHouseholdMemberConstants'

import AddHHMStyle from '../../styles/AddHouseholdMember.module.css'

const { Text } = Typography

const AddHouseholdMember = () => {
  useEffect(() => {
    window.location.href = "/404";
  }, []);

  return null;

  const [driver, setDriver] = useState({
    firstName: '',
    lastName: '',
    policyNumber: '',
    phoneNumber: '',
    streetAddress: '',
    zipCode: '',
    emailAddress: '',
    additionalHousehold: {
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      maritalStatus: '',
      gender: '',
      relationship: '',
      effectDate: ''
    }
  })
  const [disableButton, setDisableButton] = useState(false)

  const validateBasicFormData = driverInfo => {
    const {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      zipCode,
      emailAddress,
      additionalHousehold: {
        firstName: fName,
        lastName: lName,
        dateOfBirth,
        maritalStatus,
        gender,
        relationship,
        effectDate
      }
    } = driverInfo

    if (
      firstName &&
      lastName &&
      policyNumber &&
      phoneNumber &&
      streetAddress &&
      zipCode &&
      emailAddress &&
      fName &&
      lName &&
      dateOfBirth &&
      maritalStatus &&
      relationship &&
      gender &&
      effectDate
    ) {
      return { isValid: true }
    } else {
      return { isValid: false }
    }
  }

  const validateDate = driverInfo => {
    const {
      additionalHousehold: { dateOfBirth, effectDate }
    } = driverInfo

    if (new Date(dateOfBirth).toString() === 'Invalid Date' || new Date(effectDate).toString() === 'Invalid Date') {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateEmail = driverInfo => {
    const { emailAddress } = driverInfo
    const regEx = /\S+@\S+\.\S+/

    if (emailAddress.length > 0 && regEx.test(emailAddress)) {
      return { isValid: true }
    } else {
      return { isValid: false }
    }
  }

  const validateZipCode = driverInfo => {
    const { zipCode } = driverInfo

    if (zipCode.length < 5) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const formatPhoneNumber = phoneNumber => {
    const USNumber = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber ? `(${USNumber?.[1]}) ${USNumber?.[2]}-${USNumber?.[3]}` : ''
  }

  const validatePhoneNumber = driverInfo => {
    const { phoneNumber } = driverInfo
    const updatedNumber = phoneNumber.replace(/[^\w\s]/gi, '').replace(' ', '')
    if (formatPhoneNumber(updatedNumber).length < 10) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateFields = driverInfo => {
    let validationResponse = true
    const initialResponse = validateBasicFormData(driverInfo)
    if (initialResponse.isValid) {
      const dateValidationResponse = validateDate(driverInfo)
      const emailValidationResponse = validateEmail(driverInfo)
      const zipCodeValidationResponse = validateZipCode(driverInfo)
      const phoneValidationResponse = validatePhoneNumber(driverInfo)
      if (
        dateValidationResponse.isValid &&
        emailValidationResponse.isValid &&
        zipCodeValidationResponse.isValid &&
        phoneValidationResponse.isValid
      ) {
        validationResponse = true
      } else {
        validationResponse = false
      }
    } else {
      validationResponse = false
    }
    return validationResponse
  }

  const buildTable = driverInfo => {
    var table = '<table border="1">'
    table += '<tr><td colspan="2"><b>Policyholder Information</b></td></tr>'
    for (const key in driverInfo) {
      if (driverInfo[key] instanceof Object) {
        table += '<tr><td colspan="2"><b>Additional Member Information</b></td></tr>'
        for (const additionalKey in driverInfo[key]) {
          table += `<tr><td>${ADD_DRIVER_JSON_MAP[key][additionalKey]}</td><td>${driverInfo[key][additionalKey]}</td></tr>`
        }
      } else {
        table += `<tr><td>${ADD_DRIVER_JSON_MAP[key]}</td><td>${driverInfo[key]}</td></tr>`
      }
    }
    table += '</table>'
    return table
  }

  const handleSubmit = async () => {
    setDisableButton(true)
    const htmlText = buildTable(driver)
    const mailObj = {
      subject: `[Add Household Member] - ${driver.policyNumber}`,
      content: htmlText
    }
    localStorage.setItem('expressPolicyChangeType', 'Add Household Member')

    await sendEmailForExpressPolicyChanges(mailObj)

    const newWindow = window.open('/g/express-policy-changes/result', '_self', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const updateUserTextFields = (text, field) => {
    const clonedUser = { ...driver }
    clonedUser[field] = text
    setDriver(clonedUser)
  }

  const buttonStatus = !validateFields(driver) || disableButton

  return (
    <div className="container">
      <GlobalHeader />
      <>
        <EmptyHeaderHero minHeight={true} title="Add Household Member" />
        <div className={`${AddHHMStyle["add-household"]}`}>
          <p className={`${AddHHMStyle["disclaimer"]}`}>Once your change request has been approved and processed, you will be sent updated policy documents and billing schedule.</p>
          <Row>
            <Card className={`${AddHHMStyle["register-card"]}`}>
              <h5 className={`${AddHHMStyle["sub-label"]}`}>Policyholder Information</h5>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "firstName") }}
                      placeholder="First Name*"
                      value={driver.firstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "lastName") }}
                      placeholder="Last Name*"
                      value={driver.lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "policyNumber") }}
                      placeholder="Policy Number*"
                      value={driver.policyNumber}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${AddHHMStyle["input-text"]} ${AddHHMStyle["phone-number"]}`}
                      mask="(999) 999-9999"
                      onChange={event => { updateUserTextFields(event.target.value, "phoneNumber") }}
                      placeholder="Phone Number*"
                      value={driver.phoneNumber}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          streetAddress: event.target.value
                        })
                      }}
                      placeholder="Street Address*"
                      value={driver.streetAddress}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      maxLength={5}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          zipCode: event.target.value.replace(/\D/g, '')
                        })
                      }}
                      placeholder="Zip Code*"
                      value={driver.zipCode}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "emailAddress") }}
                      placeholder="Email Address*"
                      value={driver.emailAddress}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <h5 className={`${AddHHMStyle["sub-label"]}`}>Additional Household Member Information</h5>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => {
                        const additionalHousehold = {
                          ...driver.additionalHousehold,
                          firstName: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalHousehold
                        })
                      }}
                      placeholder="First Name*"
                      value={driver.additionalHousehold.firstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => {
                        const additionalHousehold = {
                          ...driver.additionalHousehold,
                          lastName: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalHousehold
                        })
                      }}
                      placeholder="Last Name*"
                      value={driver.additionalHousehold.lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${AddHHMStyle["dob"]}`}
                      mask="99/99/9999"
                      onChange={event => {
                        const additionalHousehold = {
                          ...driver.additionalHousehold,
                          dateOfBirth: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalHousehold
                        })
                      }}
                      placeholder="DOB (mm/dd/yyyy)*"
                      value={driver.additionalHousehold.dateOfBirth}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => {
                        const additionalHousehold = {
                          ...driver.additionalHousehold,
                          maritalStatus: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalHousehold
                        })
                      }}
                      placeholder="Marital Status*"
                      value={driver.additionalHousehold.maritalStatus}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => {
                        const additionalHousehold = {
                          ...driver.additionalHousehold,
                          gender: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalHousehold
                        })
                      }}
                      placeholder="Gender*"
                      value={driver.additionalHousehold.gender}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddHHMStyle["input-text"]}`}
                      onChange={event => {
                        const additionalHousehold = {
                          ...driver.additionalHousehold,
                          relationship: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalHousehold
                        })
                      }}
                      placeholder="Relationship to the Policyholder*"
                      value={driver.additionalHousehold.relationship}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Text className={`${AddHHMStyle["form-effect-label"]}`}>What date would you like this change to go into effect?*</Text>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddHHMStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${AddHHMStyle["dob"]}`}
                      mask="99/99/9999"
                      onChange={event => {
                        const additionalHousehold = {
                          ...driver.additionalHousehold,
                          effectDate: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalHousehold
                        })
                      }}
                      placeholder="mm/dd/yyyy*"
                      value={driver.additionalHousehold.effectDate}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Row>
          <Row className={`${AddHHMStyle["submit-container"]}`}>
            <Form.Item className={`${AddHHMStyle["btn-control"]} ${AddHHMStyle["button-submit-form"]}`}>
              <Space>
                <Button className={`${AddHHMStyle["register"]} ${AddHHMStyle["register-form-button"]}`} disabled={buttonStatus} onClick={handleSubmit}>
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Row>
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

AddHouseholdMember.propTypes = {}

export default AddHouseholdMember
